import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const TranslateLanguageIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M6.62594 3.0127H13.3737C15.7322 3.0127 17.1994 4.67765 17.1994 7.0338V13.3916C17.1994 15.7477 15.7322 17.4127 13.373 17.4127H6.62594C4.26746 17.4127 2.79944 15.7477 2.79944 13.3916V7.0338C2.79944 4.67765 4.27446 3.0127 6.62594 3.0127Z"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5111 12.6001C11.0949 12.8336 11.4327 12.8671 12.1021 12.8671C12.4913 12.8671 13.0393 12.6911 13.4051 12.6133"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0065 13.5916L11.9657 9.75342L13.9256 13.5916"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.44788 9.06909C7.63391 9.83349 7.99041 10.5293 8.47068 11.1132C8.63572 11.3117 8.81708 11.4985 9.01084 11.6721"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3323 7.52856C10.3789 7.62664 10.14 11.085 6.31506 12.2556"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.07422 7.52856H11.6334"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.71094 6.83423V7.5262"
        stroke={props.fill || "currentColor" || "#747981"}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TranslateLanguageIcon;
